import React from "react";
import "./Loading.css";
import { Logo } from "../../images/images";

interface SpinnerProps {
  size?: number;
}

const LoadingComponent: React.FC<SpinnerProps> = ({ size = 200 }) => {
  return (
    <div className={"spinner-container"}>
      <img
        src={Logo}
        alt="Loading..."
        className="spinner-logo"
        style={{
          width: size,
          height: size,
        }}
      />
    </div>
  );
};

export default LoadingComponent;
